import { Button, Card, CardContent, Grid, Typography } from '@mui/material'
import React from 'react'
import { AllowedAccess } from 'react-permission-role'
import { ExpensesTable } from './ExpensesTable/ExpensesTable'
import { ArrowLeftCircle, Plus } from 'react-feather'
import { ModalModule } from '../CreditsForm/Modal'

export const Expenses = ({useFetchInit}) => {

  const {
    //------------- Generales
    //------------- globalStates
    globalStates,
    //------------- Helpers
    Helpers,
    //------------- Formularios
    Forms,
    //------------- FetchData
    FetchData,
    //------------- Actions
    Actions
} = useFetchInit

const {handleClickFetchInfoExpenses, handleClickCloseExpenses} = Actions
  return (
    <AllowedAccess permissions={['237_CREDITOS']} renderAuthFailed={<p>Error</p>}>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Card
            sx={{
              zIndex: 1,
            }}
          >
          <CardContent>
            <Grid item xs={12} sm={12} md={12} lg={12} sx={{mt:1, mb:3}}>
              <div className='h4 mt-1 mb-1'> Gastos Asociados </div>
              <div className="border-bottom border-dark"></div>

              <Button
                startIcon={<Plus />}
                size='medium'
                type='button'
                variant='contained'
                color='primary'
                sx={{ marginTop: 4 }}
                // onClick={() => handleClickShowForm('EDITABLE')}
              onClick={() => handleClickFetchInfoExpenses()} 

              >
                Agregar Gasto
              </Button>

            </Grid> 

            <ExpensesTable useFetchInit={useFetchInit}/>
            <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>                
              <Grid item xs={12}>
                  <div className="text-center">
                          <Button 
                              startIcon={<ArrowLeftCircle/>}
                              variant="contained"
                              type="button" 
                              className='btn-round'
                              color='warning'
                              onClick={handleClickCloseExpenses} 
                              sx={{ marginTop: 3, marginBottom: 3 }}
                          >
                              Volver
                          </Button>
                  </div>
              </Grid>
            </Grid>

            <ModalModule useFetchInit={useFetchInit} />
          </CardContent>
          </Card>
        </Grid> 
      </Grid> 
    </AllowedAccess>
  )
}
